import { render } from "./PopupBox.vue?vue&type=template&id=6e3e0066&scoped=true&ts=true"
import script from "./PopupBox.vue?vue&type=script&lang=ts"
export * from "./PopupBox.vue?vue&type=script&lang=ts"

import "./PopupBox.vue?vue&type=style&index=0&id=6e3e0066&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e3e0066"]])

export default __exports__